module.exports = __webpack_public_path__ + "img/04.1763c135.png";